import {BrowserRouter} from 'react-router-dom';
import AuthProvider from './resources/auth/auth-provider';
import FeaturesProvider from './resources/features/features-provider';
import Router from './router';
import { MsalProvider } from '@azure/msal-react';
import {PublicClientApplication} from "@azure/msal-browser";
import msalConfig from "./config/ms-entra-auth";

const msalInstance = new PublicClientApplication(msalConfig);

export default function App() {
    return (
        <BrowserRouter>
            <MsalProvider instance={msalInstance}>
                <AuthProvider>
                    <FeaturesProvider>
                        <Router/>
                    </FeaturesProvider>
                </AuthProvider>
            </MsalProvider>
        </BrowserRouter>
    );
}
